import PropTypes from 'prop-types';
import { mostRecentCreate, sortProfiles } from 'apps/profile/components/enrichment/enrichment-utils';
import ProfileCardHeader from 'apps/profile/components/profile-card-header';
import SocialMediaTable from 'apps/profile/components/enrichment/social-media-table';
import { Icon, Modal, ModalBody, useOpenClose, Button, ButtonTooltip } from '@evertrue/et-components';
import SocialEditModal from 'apps/profile/components/social-edit-modal';
import EnrichmentModalHeader from 'apps/profile/components/enrichment/enrichment-modal-header';

const SocialEnrichment = ({ profiles = [], contact = {}, onDelete }) => {
  const lastRefresh = mostRecentCreate(profiles);
  const activeProfiles = profiles.filter((profile) => !profile.rejected);
  const [isModalOpen, openModal, closeModal] = useOpenClose();
  const sortedProfiles = sortProfiles(activeProfiles);
  // Show edit icon if there's ANY data (active or rejected)
  const hasAnyData = profiles.length > 0;

  // keep track of the count of each profile type
  const profileTypeCounts = {};
  let additionalTypesCount = 0;

  const uniqueProfiles = sortedProfiles.filter((profile) => {
    if (profile.type === '') {
      // keep count of it but don't display it.
      // it'll be displayed in the edit modal
      // with the option to delete it.
      additionalTypesCount++;
      return false;
    }
    if (!profileTypeCounts[profile.type]) {
      profileTypeCounts[profile.type] = 1;
      return true;
    } else {
      profileTypeCounts[profile.type]++;
      additionalTypesCount++;
      return false;
    }
  });

  const renderEditModal = (profiles) => (
    <Modal size="medium" isOpen={isModalOpen} closeModal={closeModal}>
      <EnrichmentModalHeader
        headerText={contact.name + "'s Social Media"}
        updateDate={lastRefresh}
        closeModal={closeModal}
      />
      <ModalBody>
        <SocialEditModal contact_id={contact.id} profiles={profiles} onDelete={onDelete} lastRefresh={lastRefresh} />
      </ModalBody>
    </Modal>
  );

  return (
    <>
      <ProfileCardHeader title="Social Media" updateDate={hasAnyData ? lastRefresh : ''} showDateAsTooltip={true}>
        {hasAnyData && (
          <Button type="simple" onClick={isModalOpen ? closeModal : openModal}>
            <Icon title="Edit Social information" icon="edit" />
          </Button>
        )}
      </ProfileCardHeader>

      {/* Body content */}
      <div className="profile--enrichment-inner">
        <SocialMediaTable profiles={uniqueProfiles} />
      </div>

      {/* Footer with "more" button */}
      {additionalTypesCount > 0 && (
        <div className="profile--enrichment-footer">
          <ButtonTooltip
            title={`View ${additionalTypesCount} more social media profile${additionalTypesCount > 1 ? 's' : ''}`}
            trigger={
              <Button
                type="simple"
                className="profile--enrichment-more-btn"
                onClick={isModalOpen ? closeModal : openModal}
              >
                (+ {additionalTypesCount} more)
              </Button>
            }
          >
            View {additionalTypesCount} more social media profile{additionalTypesCount > 1 ? 's' : ''}
          </ButtonTooltip>
        </div>
      )}

      {renderEditModal(profiles)}
    </>
  );
};

SocialEnrichment.propTypes = {
  profiles: PropTypes.array,
  contact: PropTypes.object,
  onDelete: PropTypes.func,
};

export default SocialEnrichment;
